import * as actionTypes from './actionTypes'

export const getRangeBarValue = value => {
    return {
        type : actionTypes.GET_RANGEBAR_VALUE,
        payLoad : value
    }
};

// export const getRangeBarValue = value => {
//     return {
//         type : actionTypes.GET_RANGEBAR_VALUE,
//         payLoad : value
//     }
// };


/** WEBPACK FOOTER **
 ** ./src/store/actions/rangeBarAction.js
 **/